var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',_vm._b({attrs:{"type":"area","height":"250"}},'apexchart',_vm.chartRpe,false))}
var staticRenderFns = []

export { render, staticRenderFns }